<mat-sidenav-container class="sidenav-container">
  <!-- Sidebar -->
  <mat-sidenav #sidenav mode="side" opened class="sidenav" fixedInViewport>
    <!-- Logo -->
    <div class="sidenav-header">
      <img src="../assets/logo.png" alt="Shree Maruti Logo" class="logo" />
    </div>

    <!-- Search Bar -->
    <div class="search-container">
      <app-mat-input
        label=""
        placeholder="Search"
        prefixIcon="search"
        [showClearButton]="false"
        appearance="fill"
        width="100%"
        [value]="searchText"
        (valueChange)="searchTextChange($event)"
      >
      </app-mat-input>
    </div>

    <!-- Navigation Menu -->
    <div class="sidebar-menu-container">
      <mat-nav-list>
        <!-- Dynamic Menu Items -->
        <ng-container *ngFor="let item of menuItems$ | async">
          <ng-container *ngIf="canAccessMenuItem(item)">

            <!-- Expansion Panel for items with children -->
            <mat-expansion-panel
              *ngIf="shouldShowAsExpansion(item)"
              class="sidebar-expansion-panel"
              [expanded]="isPanelExpanded(item.id)"
              data-has-children="true"
            >
              <mat-expansion-panel-header (click)="togglePanel(item.id)">
                <mat-panel-title>
                  <mat-icon>{{ item.icon }}</mat-icon>
                  <span>{{ item.label }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a
                  *ngFor="let child of item.children"
                  mat-list-item
                  [routerLink]="child.route"
                  [class.active]="isRouteActive(child.route!)"
                  (click)="$event.stopPropagation()"
                >
                  <span>{{ child.label }}</span>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>

            <!-- Single Item Panel -->
            <mat-expansion-panel
              *ngIf="shouldShowAsSingleItem(item)"
              class="sidebar-expansion-panel"
              [expanded]="false"
              hideToggle
            >
              <mat-expansion-panel-header
                [routerLink]="getSingleItemRoute(item)"
                routerLinkActive="active"
              >
                <mat-panel-title>
                  <mat-icon>{{ item.icon }}</mat-icon>
                  <span>{{ getSingleItemLabel(item) }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
            </mat-expansion-panel>

          </ng-container>
        </ng-container>

      </mat-nav-list>
    </div>

    <!-- Bottom Section -->
    <div class="sidebar-bottom">
      <div class="sidebar-settings">
        <mat-icon>settings</mat-icon>
        <span>Settings</span>
      </div>
      <mat-divider></mat-divider>
      <div class="sidebar-user-card">
        <img class="avatar" src="../assets/avatar.jpg" alt="User Avatar" />
        <div class="user-info">
          <div class="user-name">{{ user.username }}</div>
          <div class="user-email">ID: {{ user.id }}</div>
        </div>
        <button
          mat-icon-button
          class="user-action"
          aria-label="Logout"
          (click)="logout()"
        >
          <mat-icon>logout</mat-icon>
        </button>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
